import { TitleIssue } from "@Types/title_issues";
import { formatCustomersNames } from "@Pages/Applications/Applications";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

export default function Overview({ titleIssue }: { titleIssue: TitleIssue }) {
  return (
    <div>
      {renderFieldData(
        "DMV",
        titleIssue.data.deal?.data?.applicant?.data?.info?.currentState ?? ""
      )}

      {renderFieldData(
        "Applicants",
        titleIssue.data.deal ? formatCustomersNames(titleIssue.data.deal) : ""
      )}
    </div>
  );
}
